import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-give',
  templateUrl: './give.component.html',
  styleUrls: ['./give.component.scss']
})
export class GiveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
